import { apiCall, API_CONFIG } from './api';

export const analyticsAPI = {
  // Get user analytics 
  getUserAnalytics: async (timeFrame, deviceType) => {
    try {
      const queryParams = new URLSearchParams();
      if (timeFrame) queryParams.append('timeFrame', timeFrame);
      if (deviceType) queryParams.append('deviceType', deviceType);

      const endpoint = `${API_CONFIG.ENDPOINTS.USER_ANALYTICS}?${queryParams.toString()}`;
      const response = await apiCall(endpoint, {
        method: 'GET',
      });
      return response;
    } catch (error) {
      console.error('Failed to fetch user analytics:', error);
      throw error;
    }
  },

  // Get user action logs count
  getUserActionLogsCount: async (timeFrame, deviceType) => {
    try {
      const queryParams = new URLSearchParams();
      if (timeFrame) queryParams.append('timeFrame', timeFrame);
      if (deviceType) queryParams.append('deviceType', deviceType);

      const endpoint = `${API_CONFIG.ENDPOINTS.USER_ACTION_LOGS_COUNT}?${queryParams.toString()}`;
      const response = await apiCall(endpoint, {
        method: 'GET',
      });
      return response;
    } catch (error) {
      console.error('Failed to fetch user action logs count:', error);
      throw error;
    }
  },

  getHourlySummary: async (dateFilter, startDate, deviceType) => {
    try {
      const queryParams = new URLSearchParams();
      if (dateFilter) queryParams.append('dateFilter', dateFilter);
      if (startDate) queryParams.append('startDate', startDate);
      if (deviceType) queryParams.append('deviceType', deviceType);

      const endpoint = `${API_CONFIG.ENDPOINTS.HOURLY_SUMMARY}?${queryParams.toString()}`;
      const response = await apiCall(endpoint, {
        method: 'GET',
      });
      return response;
    } catch (error) {
      console.error('Failed to fetch hourly summary:', error);
      throw error;
    }
  },

};